import { useState } from "react";
import { useDispatch } from "react-redux";
import { GeoCityLocationAction } from "../../redux/location";
import GeoLocationButton from "./GeoLocationButton";


const SearchBar = () => {

    const dispatch = useDispatch()
    const [cityName, setCityName] = useState('')

    const handleChangeCity = (e) => {
        setCityName(e.target.value)
        
    }

    const handleClick = () => {

        dispatch(GeoCityLocationAction({cityName}))

    }
    
    
    return (

        <div className="searchBar">
                <div className="searchBar__button">
                    <GeoLocationButton/>
                </div>
                <input className="inputSearch" onChange={handleChangeCity} placeholder="Search by city" value={cityName}></input>
                <button className="searchButton" onClick={handleClick}>
                    <img src={require("../../img/search.svg").default} />
                </button>
        </div>  
        
    )
}

export default SearchBar
